import { render, staticRenderFns } from "./DrawerSpaceSettingsSection.vue?vue&type=template&id=9a6401a6&"
import script from "./DrawerSpaceSettingsSection.vue?vue&type=script&lang=js&"
export * from "./DrawerSpaceSettingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports